<template>
    <div class="item">
        <label class="check_wrap">
            <input type="checkbox" v-model="account.isSelected">
            <span class="checkmark"></span>
            {{ title }}
        </label>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            account: {}
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                this.account = deepCopy(newValue)
            }
        },
        'account.isSelected': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        }
    },
    computed: {
        name: function() {
            return this.account?.realName ?? ''
        },
        id: function() {
            return this.account?.id ?? ''
        },
        title: function() {
            return this.name + '(' + this.id + ')'
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.account)
        }
    }
}
</script>